.table {
  width: 100%;
  border-collapse: collapse;
}

.cell {
  padding: 6px 12px;
  border-bottom: 1px solid var(--tuna-palette-divider, #e0e0e0);
  vertical-align: middle;
}

.headerCell {
  padding: 6px 12px;
  border-bottom: 1px solid var(--tuna-palette-divider, #e0e0e0);
  vertical-align: middle;
  font-weight: 600;
  font-size: 0.875rem;
  color: var(--tuna-palette-text-secondary, #666);
  text-align: left;
  background-color: var(--tuna-palette-background-default, #fafafa);
}

.actionsCell {
  padding: 6px 12px;
  border-bottom: 1px solid var(--tuna-palette-divider, #e0e0e0);
  vertical-align: middle;
  white-space: nowrap;
}

.actionsHeaderCell {
  padding: 6px 12px;
  border-bottom: 1px solid var(--tuna-palette-divider, #e0e0e0);
  vertical-align: middle;
  font-weight: 600;
  font-size: 0.875rem;
  color: var(--tuna-palette-text-secondary, #666);
  text-align: left;
  background-color: var(--tuna-palette-background-default, #fafafa);
  width: 100px;
}

.input {
  font: inherit;
  padding: 4px 8px;
  border: 1px solid var(--tuna-palette-divider, #ccc);
  border-radius: 4px;
  background-color: var(--tuna-palette-background-paper, #fff);
  color: var(--tuna-palette-text-primary, inherit);
  width: 100%;
  box-sizing: border-box;
}

.emptyCell {
  padding: 6px 12px;
  border-bottom: 1px solid var(--tuna-palette-divider, #e0e0e0);
  vertical-align: middle;
  text-align: center;
  color: var(--tuna-palette-text-secondary, #999);
}
